import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c98dd6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "client_chat_wrapper" }
const _hoisted_2 = { class: "chat_body_wrapper" }
const _hoisted_3 = { class: "chat_body_top_wrapper" }
const _hoisted_4 = { class: "chat_body_top" }
const _hoisted_5 = { class: "button_text" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "button_exit_img",
  src: "/assets/img/logout.svg"
}, null, -1))
const _hoisted_7 = { class: "button_text" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "button_owner_img",
  src: "/assets/img/edit-name-white.svg"
}, null, -1))
const _hoisted_9 = { class: "chat_content_wrapper" }
const _hoisted_10 = {
  class: "chat_body",
  id: "clientChatMessages"
}
const _hoisted_11 = {
  key: 0,
  class: "info_text"
}
const _hoisted_12 = {
  key: 1,
  class: "start_chat_wrapper"
}
const _hoisted_13 = { class: "info_text_static" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "button_start_chat_img",
  src: "/assets/img/send.svg"
}, null, -1))
const _hoisted_15 = {
  key: 0,
  class: "technical_message"
}
const _hoisted_16 = { class: "m-0" }
const _hoisted_17 = {
  key: 0,
  class: "message_date"
}
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = {
  key: 0,
  class: "message_date"
}
const _hoisted_20 = { class: "chat_body_footer" }
const _hoisted_21 = ["title"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "template_button_img",
  src: "/assets/img/document-folder.svg"
}, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = ["placeholder"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "message_send_button_img",
  src: "/assets/img/send.svg"
}, null, -1))
const _hoisted_26 = [
  _hoisted_25
]

export function render(_ctx, _cache) {
  const _component_ChatTemplateDropdown = _resolveComponent("ChatTemplateDropdown")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.isOwner)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "button_exit",
                onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.removeOwner && _ctx.removeOwner(...args)))
              }, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('chat.exit_chat')), 1),
                _hoisted_6
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isOwner && _ctx.roomId)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "button_owner",
                onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.assignAsOwner && _ctx.assignAsOwner(...args)))
              }, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('chat.become_owner')), 1),
                _hoisted_8
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", {
          class: "overflow-hidden",
          style: _normalizeStyle({ 'min-height': `calc(100% - ${36 + _ctx.textareaHeight}px)` })
        }, [
          _createElementVNode("div", _hoisted_10, [
            (_ctx.messageInformation)
              ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.messageInformation ? _ctx.$t(_ctx.messageInformation) : _ctx.messageInformation), 1))
              : (_ctx.showStartChat)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('chat.no_chat_for_client')), 1),
                    _createElementVNode("button", {
                      class: "button_start_chat",
                      onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.createRoom && _ctx.createRoom(...args)))
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('chat.start_chat')), 1),
                      _hoisted_14
                    ])
                  ]))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.messages, (message) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: message.messageId
                    }, [
                      (message.isTechnicalMessage)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("p", _hoisted_16, _toDisplayString(message.isTranslated ? _ctx.$t(message.text) : message.text), 1),
                            (!message.isTechnicalMessage)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(message.sendDate), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: _normalizeClass(message.isClubMessage ? 'club_message' : 'client_message')
                          }, [
                            _createElementVNode("p", {
                              class: "m-0",
                              innerHTML: message.text
                            }, null, 8, _hoisted_18),
                            (!message.isTechnicalMessage)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(message.sendDate), 1))
                              : _createCommentVNode("", true)
                          ], 2))
                    ]))
                  }), 128))
          ])
        ], 4),
        _createElementVNode("div", {
          class: "chat_body_footer_wrapper",
          style: _normalizeStyle({ 'min-height': `${36 + _ctx.textareaHeight}px` })
        }, [
          _createVNode(_component_ChatTemplateDropdown, {
            show: _ctx.isTemplatesOpen,
            templates: _ctx.templates,
            loading: _ctx.isTemplatesLoading,
            error: _ctx.templatesError,
            onSelect: _ctx.selectTemplate,
            onClose: _cache[3] || (_cache[3] = $event => (_ctx.isTemplatesOpen = false))
          }, null, 8, ["show", "templates", "loading", "error", "onSelect"]),
          _withDirectives(_createElementVNode("div", _hoisted_20, [
            (_ctx.showTemplatesButton)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: _normalizeClass(["template_button", { template_button_active: _ctx.isTemplatesOpen }]),
                  onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.toggleTemplates && _ctx.toggleTemplates(...args))),
                  title: _ctx.$t('chat.templates')
                }, _hoisted_23, 10, _hoisted_21))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["textarea_wrapper", { active: _ctx.isTextareaFocused, 'no-template-button': !_ctx.showTemplatesButton }])
            }, [
              _withDirectives(_createElementVNode("textarea", {
                placeholder: _ctx.$t('chat.enter_message'),
                class: "textarea",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.message) = $event)),
                onKeydown: _cache[6] || (_cache[6] = $event => (_ctx.updateTextarea($event))),
                onInput: _cache[7] || (_cache[7] = (...args) => (_ctx.changeTextArea && _ctx.changeTextArea(...args))),
                onFocus: _cache[8] || (_cache[8] = $event => (_ctx.isTextareaFocused = true)),
                onBlur: _cache[9] || (_cache[9] = $event => (_ctx.isTextareaFocused = false)),
                id: "clientChatTextarea"
              }, null, 40, _hoisted_24), [
                [_vModelText, _ctx.message]
              ])
            ], 2),
            _createElementVNode("button", {
              class: "message_send_button",
              onClick: _cache[10] || (_cache[10] = (...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)))
            }, _hoisted_26)
          ], 512), [
            [_vShow, _ctx.isOwner && !_ctx.connectionInformation]
          ]),
          _withDirectives(_createElementVNode("p", { class: "info_text" }, _toDisplayString(_ctx.connectionInformation ? _ctx.$t(_ctx.connectionInformation) : _ctx.connectionInformation), 513), [
            [_vShow, _ctx.connectionInformation]
          ])
        ], 4)
      ])
    ])
  ]))
}